import { useSEO } from "../hook";
import { Button, Card, Skeleton } from "antd";
import Link from "next/link";
import { useTheme } from "../../../Styles/ThemeHook";
import "./styles.less";
import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { Binoculars, MapPinHouse } from "lucide-react";

export const LastSearchCard = () => {
	const { seoMetaTags, loading: load } = useSEO();
	const { site_name } = useContext(ConfigStateContext);
	const { theme } = useTheme();
	if (load)
		return (
			<Card size={"small"} className="more-similars">
				<Skeleton active />
			</Card>
		);

	if (!seoMetaTags.lastSearch) {
		return null;
	}

	const link = seoMetaTags.lastSearch.url;
	const locationName = seoMetaTags.lastSearch.text;

	return (
		<Link href={link} passHref>
			<div className="last-search-card">
				<div className="last-search-card-content">
					<Binoculars className="last-search-card-icon last-search-card-icon--header"/> <p>Ver más propiedades en {site_name}</p>
				</div>
				<hr />
				<div className="last-search-card-footer">
					<MapPinHouse className="last-search-card-icon last-search-card-icon--footer"/> <p>{locationName}</p>
				</div>
				<Button type="primary" size="large" className="last-search-card-button">{"Ver Más"}</Button>
			</div>
		</Link>
	);
};
